export interface ScvConnectorConfig {
  userPresenceStatuses: string;
  scrtUrl: string;
}

export class ScvConfigStorage {
  private static config: ScvConnectorConfig;

  static store(config: ScvConnectorConfig) {
    this.config = config;
  }

  static get() {
    return this.config;
  }
}
